import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnJP: CultureInfo = {
  name: 'en-JP',
  displayName: 'English (Japan)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-JP',
  parent: CultureInfoEn
};
